<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog title="修改分类" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="所属分类" :label-width="formLabelWidth">
        <el-select v-model="form.parent_id">
          <el-option label="顶级分类" :value="0"></el-option>
          <el-option :value="cat.category_id" :label="cat.name" :key="cat.category_id" v-for="cat in editform.catList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分类名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分类图片" prop="image_id" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="分类排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分类图片小图" prop="image_id_1" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload1">选择图片</el-button>
          <div v-if="form.image_id_1!=''" class="img">
            <img :src="file_path_1" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      
      <!-- 新增：选择主管 -->
      <el-form-item label="选择主管" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openSelectManager">选择主管</el-button>
          <div v-if="form.manager_user" class="user-info">
            <div class="user-avatar">
              <img :src="form.manager_user.avatarUrl || form.manager_user.avatar_url" width="40" height="40" style="border-radius: 50%;" />
            </div>
            <div class="user-details">
              <p><strong>昵称：</strong>{{ form.manager_user.nickName || form.manager_user.nickname }}</p>
              <p><strong>手机：</strong>{{ form.manager_user.mobile }}</p>
            </div>
          </div>
        </el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Upload v-if="isupload1" :isupload="isupload1" :type="type1" @returnImgs="returnImgsFunc1">上传图片</Upload>
    
    <!-- 选择主管对话框 -->
    <GetUser :is_open="open_select_manager" @close="closeSelectManager"></GetUser>
  </el-dialog>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetDepart.vue';
  
  export default {
    components: {
      Upload,
      GetUser
    },
    data() {
      return {
        form: {
          category_id: 0,
          parent_id: 0,
          name: '',
          image_id: '',
          image_id_1: '',
          sort: '',
          manager_user_id: '', // 新增：主管用户ID
          manager_user: null   // 新增：主管用户信息
        },
        file_path: '',
        file_path_1: '',
        formRules: {
          name: [{
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          }],
          image_id: [{
            required: true,
            message: '请上传分类图片',
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: '分类排序不能为空'
          }, {
            type: 'number',
            message: '分类排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
        isupload1: false,
        /*选择主管对话框*/
        open_select_manager: false
      };
    },
    props: ['open_edit', 'editform'],
    created() {
      this.dialogVisible = this.open_edit;
      console.log(this.editform.model);
      this.form.category_id = this.editform.model.category_id;
      this.form.parent_id = this.editform.model.parent_id;
      this.form.name = this.editform.model.name;
      this.form.sort = this.editform.model.sort;
      
      // 如果有主管信息，初始化主管数据
      if (this.editform.model.manager_user_id) {
        this.form.manager_user_id = this.editform.model.manager_user_id;
        this.form.manager_user = this.editform.model.manager_user;
      }
      
      this.getImage(this.editform.model.category_id);
    },
    methods: {
      /*修改用户*/
      addUser() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PorductApi.catEdit(params, true).then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
      
      getImage(category_id) {
        PorductApi.cateImage({
          category_id: category_id
        }, true).then(data => {
          this.form.image_id = data.data.detail.image_id;
          this.file_path = data.data.detail.image.file_path;
          this.form.image_id_1 = data.data.detail.image_id_1;
          this.file_path_1 = data.data.detail.image1.file_path;
          console.log('1111111111111',data.data.detail);
          
          
          // 如果有主管信息，设置主管数据
          if (data.data.detail.manager_user) {
            this.form.manager_user = data.data.detail.manager_user;
            this.form.manager_user_id = data.data.detail.manager_user_id;
          }
        }).catch(error => {});
      },
      
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      
      /*上传*/
      openUpload1(e) {
        this.type1 = e;
        this.isupload1 = true;
      },
      
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      
      /*获取图片*/
      returnImgsFunc1(e) {
        if (e != null && e.length > 0) {
          this.file_path_1 = e[0].file_path;
          this.form.image_id_1 = e[0].file_id;
        }
        this.isupload1 = false;
      },
      
      /*打开选择主管对话框*/
      openSelectManager() {
        this.open_select_manager = true;
      },
      
      /*关闭选择主管对话框*/
      closeSelectManager(e) {
        if (e.type != 'error') {
          // 设置主管信息
          const selectedUser = e.params[0];
          this.form.manager_user = {
            ...selectedUser,
            avatarUrl: selectedUser.avatarUrl || selectedUser.avatar_url,
            nickName: selectedUser.nickName || selectedUser.nickname
          };
          this.form.manager_user_id = selectedUser.user_id;
        }
        this.open_select_manager = false;
      }
    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
  
  /* 新增：主管信息样式 */
  .user-info {
    display: flex;
    align-items: center;
    margin-top: 10px;
    padding: 10px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    background-color: #f9f9f9;
  }
  
  .user-avatar {
    margin-right: 15px;
  }
  
  .user-details {
    flex: 1;
  }
  
  .user-details p {
    margin: 2px 0;
    font-size: 12px;
    color: #666;
  }
</style>


// WEBPACK FOOTER //
// src/views/product/category/Edit.vue